import React from 'react';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';

import iconSet from '../../../assets/icons.json';
import ErrorService from '../../../services/ErrorService';
import InfoError from '../../models/InfoError';

import { StyledSVG } from './Styles';

const propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  clickHandler: PropTypes.func,
  tooltip: PropTypes.string
};

const defaultProps = {
  className: '',
  color: undefined,
  clickHandler: undefined,
  tooltip: undefined
};

const Icon = ({ color, icon, tooltip, className, clickHandler }) => {
  const curIcon = iconSet.icons.filter(iconArr => {
    return iconArr.children.some(childArr => {
      return childArr.name === 'title' && childArr.children[0].value === icon;
    });
  });
  if (!curIcon[0]) {
    ErrorService.trackError(new InfoError(`icon ${icon} does not exist.`));
    return null;
  }

  const paths = [];
  const currentIcon = curIcon[0];
  currentIcon.children.forEach(path => {
    if (path.name === 'path') {
      paths.push(path.attributes);
    }
  });

  return (
    <StyledSVG
      onClick={clickHandler}
      className={className}
      version={currentIcon.attributes.version}
      xmlns={currentIcon.attributes.xmlns}
      width={currentIcon.attributes.width}
      height={currentIcon.attributes.height}
      viewBox={currentIcon.attributes.viewBox}
      color={color}
      data-testid={icon}
    >
      {tooltip && <title>{tooltip}</title>}
      {paths.map(path => {
        return <path key={icon + uuid()} {...path} />;
      })}
    </StyledSVG>
  );
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
